import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IMyCompanySite} from "../../../../../../utils/interfaces/my_company/my_company_site/IMyCompanySite";


const useApiUpdateMyCompanySite = (): UseMutationResult<IMyCompanySite, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCompany} = useAuth()

    const {put} = useApiCalls()

    async function doUpdate(company_token: string | undefined,
                            pk: number | undefined,
                            data: any): Promise<IMyCompanySite> {
        try {
            const response = await put(`/api/company/${company_token}/my_company/my_company_site/${pk}/`, data);
            return response.data as IMyCompanySite;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IMyCompanySite, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(selectedCompany?.company_token, id, data);
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({queryKey: ['useApiGetMyCompanySite', data.id]});
            await queryClient.invalidateQueries({queryKey: ["useApiGetMyCompanySites"]});
        },
    });
};


export default useApiUpdateMyCompanySite;